import { CostTransactionDto } from "../../../dtos/transactions/CostTransactionDto";
import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Grouping,
  GroupPanel,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";

interface IProps {
  items: CostTransactionDto[];
}

export const CostTransactionTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column
            dataField="tableMovementType"
            dataType="string"
            caption={"Movement Type"}
            width={100}
            cellRender={(column: any) => {
              return <MovementTypeColumn column={column} />;
            }}
          />

          <Column
            width={150}
            dataField={"period"}
            dataType={"datetime"}
            caption={"Period"}
            sortOrder={"asc"}
            sortIndex={1}
          />
          <Column width={150} dataField={"documentId"} dataType="string" />

          <Column width={150} dataField={"companyId"} dataType="string" />
          <Column width={150} dataField={"companyName"} dataType="string" />
          <Column width={150} dataField={"warehouseId"} dataType="string" />
          <Column width={150} dataField={"warehouseName"} dataType="string" />
          <Column width={150} dataField={"productId"} dataType="string" />
          <Column width={150} dataField={"productName"} dataType="string" />
          <Column width={150} dataField={"featureId"} dataType="string" />
          <Column width={150} dataField={"qualityId"} dataType="string" />
          <Column width={150} dataField={"seriesId"} dataType="string" />
          <Column width={150} dataField={"quantity"} dataType="number" />
          <Column width={150} dataField={"amount"} dataType="number" />
          <Column
            width={150}
            dataField={"additionalExpense"}
            dataType="number"
          />
          <Column
            width={150}
            dataField={"additionalExpenseAdm"}
            dataType="number"
          />
          <Column
            width={150}
            dataField={"additionalExpenseAcc"}
            dataType="number"
          />
          <Column
            width={150}
            dataField={"productBatchName"}
            dataType="string"
          />
          <Column width={150} dataField={"productBatchId"} dataType="string" />
          <Column width={150} dataField={"expenseItemName"} dataType="string" />
          <Column width={150} dataField={"incomeItemName"} dataType="string" />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
